export const locale = {
    lang: 'en',
    data: {
        TABLE_USER: {
            COLUMNS: {
                TITLE: 'User',
                LOGINNAME: 'Loginname',
            },
            NEW: 'Add user',
            NOTIFICATIONS: {
                REMOVED: 'User removed from group!',
            },
        },
    },
};
